import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles(({ spacing }: Theme) => ({
  progress: ({ margin = '0' }: { margin: string | undefined }) => ({
    margin,
  }),
  label: {
    marginTop: spacing(1),
  },
  boxCentered: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default useStyles;
